<ng-container *ngIf="filled" i18n="etat offre emploi|offre pourvue">Pourvu</ng-container>
<ng-container *ngIf="newed" i18n="etat offre emploi|nouvelle offre">Nouveau</ng-container>
<ng-container *ngIf="expiring" i18n="etat offre emploi">Expire bientôt</ng-container>
